import React from 'react'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { useTranslation } from 'react-i18next'
import { useDisplayTheme } from 'hooks/useUiState'
import { SerializedError } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import { clearDashboardError } from 'features/dashboard/dashboardSlice'

interface ErrorDialogProps {
  open: boolean
  errorInfo?:
    | string
    | SerializedError
    | null
    | {
        error: string
        info?: string[]
        status: number
      }
  onClose?: () => void
}

const ErrorDialog = ({ open, errorInfo, onClose }: ErrorDialogProps) => {
  const displayTheme = useDisplayTheme()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  return (
    <Dialog mode={displayTheme} open={open} onClose={onClose} width="600px">
      <Dialog.DialogTitle>{t('alert')}</Dialog.DialogTitle>
      <Dialog.DialogContent width="600px"> {errorInfo || t('error.unknown')}</Dialog.DialogContent>
      <Dialog.DialogActions
        closeButtonProps={{
          children: t('ok'),
          onClick: () => {
            dispatch(clearDashboardError())
            if (onClose) {
              onClose()
            }
          }
        }}
      />
    </Dialog>
  )
}

export default ErrorDialog
